"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const axios_1 = __importDefault(require("axios"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const strings_1 = require("../../../../../../../constants/strings");
const StyledMuiTelInput_1 = require("../../../../../../../material-ui-theme/components/styled/StyledMuiTelInput");
const sessionQuery_1 = require("../../../../../../../queries/sessionQuery");
const zustandStore_1 = require("../../../../../../../zustandStore");
const addPeopleAside_1 = require("../../../../../../organisms/createTeamModal/addPeople/addPeopleAside");
const formWrapper_1 = __importDefault(require("../../../formWrapper"));
const useValidation_1 = require("../../../hooks/useValidation");
const formInput_1 = __importDefault(require("../../common/formInput"));
const termsAndConditionsFormFooter_1 = __importDefault(require("../../common/termsAndConditionsFormFooter"));
const validationSchema_1 = require("./validationSchema");
const lexico = new lexico_1.default();
// HSBC
const RegisterForm = () => {
    const navigate = (0, react_router_1.useNavigate)();
    const [formState, setFormState] = (0, react_1.useState)({
        firstName: '',
        lastName: '',
        username: '',
        phoneCountryCode: '',
        phoneNumber: '',
        companyName: '',
        phoneNumberValue: '',
    });
    const register = (0, sessionQuery_1.useRegisterQuery)();
    const { validateField, clearFieldError, fieldErrors } = (0, useValidation_1.useValidation)();
    const { setCurrentStep, steps, setNotification, setPageLoading } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => {
            const updatedState = { ...prev, [name]: value };
            clearFieldError(name);
            return updatedState;
        });
    };
    const handleBlur = (e) => {
        if (!e || !e.target) {
            return;
        }
        const { name = '' } = e.target;
        if (name === 'phoneNumber' && formState.phoneNumberValue.length > 0) {
            validateField(validationSchema_1.registerSchema, 'phoneNumberValue', formState);
        }
        else {
            validateField(validationSchema_1.registerSchema, name, formState);
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setPageLoading(true);
        register.mutate({
            firstName: formState.firstName.trim(),
            lastName: formState.lastName.trim(),
            username: formState.username.trim(),
            companyName: formState.companyName.trim(),
            phoneCountryCode: formState.phoneCountryCode.trim(),
            phoneNumber: formState.phoneNumber.trim(),
        }, {
            onSuccess: async () => {
                setCurrentStep(steps.currentStep + 1);
                void navigate('/signin/message', {
                    state: {
                        heading: lexico.trc('Component title', 'Success!'),
                        message: lexico.tr('If your email is not yet registered, we’ll send you an activation email with details on how to proceed.'),
                    },
                });
            },
            onError: (err) => {
                let errorMessage = lexico.tr('An unexpected error occurred, please try again later.');
                if (axios_1.default.isAxiosError(err) && err.response) {
                    const { status, data } = err.response;
                    if (status >= 400 && data.errorMessage) {
                        errorMessage = data.errorMessage;
                    }
                }
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: errorMessage,
                    },
                ]);
            },
            onSettled: () => {
                setPageLoading(false);
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(formWrapper_1.default, { formName: "Create an account", onSubmit: handleSubmit, submitButton: {
            label: 'Register',
            isDisabled: !validationSchema_1.registerSchema.safeParse(formState).success,
        }, isFormPending: register.isPending, formFooter: (0, jsx_runtime_1.jsx)(termsAndConditionsFormFooter_1.default, {}), children: [(0, jsx_runtime_1.jsx)("b", { style: {
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '18px',
                    color: '#000000',
                }, children: "This page is currently rendered only on stack enviroments for testing purposes" }), (0, jsx_runtime_1.jsx)(formInput_1.default, { label: "First Name", name: "firstName", value: formState.firstName, error: fieldErrors['firstName'], onChange: handleInputChange, onBlur: handleBlur }), (0, jsx_runtime_1.jsx)(formInput_1.default, { label: "Last Name", name: "lastName", value: formState.lastName, error: fieldErrors['lastName'], onChange: handleInputChange, onBlur: handleBlur }), (0, jsx_runtime_1.jsx)(formInput_1.default, { label: "Email", name: "username", type: "email", value: formState.username, error: fieldErrors['username'], onChange: handleInputChange, onBlur: handleBlur }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { padding: '0 10px' }, margin: "normal", error: !!fieldErrors['phoneNumberValue'], children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { id: "phoneNumber", children: "Phone Number *" }), (0, jsx_runtime_1.jsx)(StyledMuiTelInput_1.StyledMuiTelInput, { sx: { padding: 0 }, slotProps: {
                            input: {
                                name: 'phoneNumber',
                                required: true,
                                autoFocus: false,
                            },
                        }, error: !!fieldErrors['phoneNumberValue'], defaultCountry: addPeopleAside_1.defaultCountryCodePhoneNumber, onlyCountries: addPeopleAside_1.onlyCountriesCodePhoneNumbers, forceCallingCode: true, focusOnSelectCountry: true, MenuProps: { disableAutoFocusItem: true }, value: formState.phoneNumberValue, onChange: (value, info) => {
                            setFormState(prevState => ({
                                ...prevState,
                                phoneCountryCode: `+${info.countryCallingCode}`,
                                phoneNumber: info.nationalNumber || '',
                                phoneNumberValue: value || '',
                            }));
                            clearFieldError('phoneNumberValue');
                        }, onBlur: handleBlur }), fieldErrors['phoneNumberValue'] && Array.isArray(fieldErrors['phoneNumberValue'])
                        ? fieldErrors['phoneNumberValue'].map((err, index) => ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { style: {
                                marginLeft: '0px',
                                marginTop: '10px',
                            }, children: [(0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "small", style: { verticalAlign: 'middle' } }), " ", String(err)] }, index)))
                        : fieldErrors['phoneNumberValue'] && ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { style: {
                                marginLeft: '0px',
                                marginTop: '10px',
                            }, children: [(0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "small", style: { verticalAlign: 'middle' } }), " ", fieldErrors['phoneNumberValue']] }))] }), (0, jsx_runtime_1.jsx)(formInput_1.default, { label: "Company Name", name: "companyName", value: formState.companyName, error: fieldErrors['companyName'], onChange: handleInputChange, onBlur: handleBlur })] }));
};
exports.default = RegisterForm;
